import { Delivery } from 'src/app/models/delivery.model';
import { Position } from 'src/app/models/position.model';
import { UserCredentials } from 'src/app/models/userCredential.model';
import { SenderParty } from '../../models/sender-party.model';
import { SenderContactPoint } from '../../models/sender-contact-point';
import { PostalShoppingScenarios } from 'src/app/models/postal-shopping.model';
/** OrderDetailsState */
export class OrderDetailsState {
    /** delivery */
    public delivery: Delivery;
    /** moreInfo */
    public moreInfo: boolean;
    /** loggedIn */
    public loggedIn: boolean;
    /** errorObject */
    public errorObject: any;
    /** refreshUserData */
    public refreshUserData: boolean;
    /** cameFromOverview */
    public cameFromOverview: boolean;
    /** changedPosition */
    public changedPosition: { [key: string]: Position[]; };
    /** userCredentials */
    public userCredentials: UserCredentials;
    /** c_id */
    public c_id: string;
    /** userAddressData */
    public userAddressData: {
        /** senderParty */
        senderParty: SenderParty,
        /** senderContactPoints */
        senderContactPoints: SenderContactPoint };
    /**  postalShoppingScenario */
    public postalShoppingScenario?: PostalShoppingScenarios;
}
